import {
  FindUsersGlobalInput,
  FindUsersGlobalResult
} from "../../../../types/gqlTypes/graphql"
import { FIND_USERS_GLOBAL } from "./orgGlobalSearchQueries"

import { executeQuerySideload } from "../../helpers/studyPlan"

export const findUsersGlobal = async (
  data: FindUsersGlobalInput
): Promise<FindUsersGlobalResult> => {
  const response = await executeQuerySideload(FIND_USERS_GLOBAL, {
    data
  })
  return response.usersManagement.findGlobal
}
